const VideoView = () => {
  return null
}

export default VideoView
